import React, { FC, ComponentProps as CP } from 'react'
import groupBy from 'lodash-es/groupBy'
import Grid from '@material-ui/core/Grid'
import SortablePlayerList from 'components/SortablePlayerList'

type Props = CP<typeof SortablePlayerList>

const SplitPlayerList: FC<Props> = ({ availablePlayers, ...props }) => {
  const groupedPlayers = groupBy(availablePlayers, (player) => player.team?.teamId)

  return (
    <Grid
      container
      spacing={4}
    >
      <Grid
        item
        xs={6}
      >
        <SortablePlayerList
          {...props}
          availablePlayers={groupedPlayers[props.match.homeTeam?.teamId || '']}
        />
      </Grid>
      <Grid
        item
        xs={6}
      >
        <SortablePlayerList
          {...props}
          availablePlayers={groupedPlayers[props.match.awayTeam?.teamId || '']}
        />
      </Grid>
    </Grid>
  )
}

export default SplitPlayerList
try {
    // @ts-ignore
    SplitPlayerList.displayName = "SplitPlayerList";
    // @ts-ignore
    SplitPlayerList.__docgenInfo = { "description": "", "displayName": "SplitPlayerList", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/TeamEditor/components/SplitPlayerList.tsx#SplitPlayerList"] = { docgenInfo: SplitPlayerList.__docgenInfo, name: "SplitPlayerList", path: "src/components/TeamEditor/components/SplitPlayerList.tsx#SplitPlayerList" };
}
catch (__react_docgen_typescript_loader_error) { }